{
  "nav": {
    "students": "Students",
    "subjects": "Subjects"
  },
  "list": {
    "title": "Students",
    "subtitle": "Manage students",
    "add": "Add student",
    "import": "Import Excel/CSV",
    "search": "Search by student name...",
    "name": "Student",
    "payer": "Payer",
    "openPayer": "Open payer profile",
    "added": "Added",
    "empty": "No students yet",
    "emptyTeachBody": "Add your first student, or import from Excel.",
    "filterMissBody": "Try removing some filters, or turn on showing stopped students.",
    "emptyActiveOnly": "No students are currently studying.",
    "noResults": "No students found",
    "loading": "Loading...",
    "nickname": "Other name",
    "sortNewest": "Newest",
    "sortOldest": "Oldest",
    "sortName": "Name A→Z",
    "sortPayer": "By payer",
    "prev": "Previous",
    "next": "Next",
    "pageOf": "Page {{page}}/{{pages}} · {{total}} students",
    "filters": "Filters",
    "filterClear": "Clear",
    "filterShowInactive": "Include stopped students",
    "filterNoEnrollment": "Not enrolled",
    "filterNoEnrollmentExclusive": "Students who aren't enrolled have no subject to filter by.",
    "filterNoSlot": "Not assigned to a slot",
    "filterSubjects": "Subjects",
    "filterModes": "Payment type",
    "modeSessionMonthly": "Per session",
    "modeSessionTerm": "Per term",
    "modeMonthlyFlat": "Fixed monthly",
    "filterTags": "Tags",
    "subjects": "Subjects",
    "noEnrollmentChip": "Not enrolled",
    "noSlotChip": "Not assigned",
    "khoaLeft": "{{count}} session(s) left",
    "khoaOut": "Term used up",
    "addManual": "Add manually",
    "loadError": "Could not load students. Try again.",
    "countSubtitle": "{{count}} students",
    "classesColumn": "Classes",
    "classPartial": "({{joined}}/{{total}})",
    "filterClasses": "Classes",
    "filterClassesSearch": "Search classes…",
    "filterClassesEnded": "Ended",
    "filterClassesEmpty": "No matching classes",
    "filterClassesFootnote": "Ended classes are listed last.",
    "appliedClassChip": "Class: {{name}}",
    "filterButtonShort": "Filter",
    "filterButtonCount": "Filter · {{count}}"
  },
  "status": {
    "ACTIVE": "Active",
    "INACTIVE": "Inactive"
  },
  "create": {
    "title": "Add student",
    "description": "Add a student and their payer",
    "selfPay": "Self-paying (adult learner)",
    "payerSection": "Payer",
    "existingPayer": "Choose an existing payer",
    "payerSearchPlaceholder": "Search by name or phone...",
    "payerEmpty": "No payer found",
    "newPayer": "or create a new payer",
    "payerName": "Payer name",
    "payerPhone": "Phone / Zalo",
    "payerEmail": "Email",
    "dupPayerWarning": "This phone already belongs to payer {{name}} — reuse it?",
    "cancel": "Cancel",
    "submit": "Add",
    "submitting": "Saving...",
    "tags": "Tags"
  },
  "fields": {
    "name": "Full name",
    "namePlaceholder": "e.g. Nguyễn Văn An",
    "nickname": "Nickname",
    "nicknamePlaceholder": "e.g. Bơ",
    "dob": "Date of birth",
    "gender": "Gender",
    "genderUnspecified": "— Not set",
    "genderMale": "Male",
    "genderFemale": "Female"
  },
  "detail": {
    "back": "Back",
    "payer": "Payer",
    "identityBadge": "Student",
    "nickname": "Nickname",
    "dob": "Date of birth",
    "notes": "Notes",
    "enrollments": "Enrollments",
    "addEnrollment": "Add enrollment",
    "viewMonthAttendance": "View this month's attendance",
    "activity": {
      "title": "Activity",
      "empty": "No activity yet.",
      "viewAll": "View all activity",
      "orgLog": "View the whole organisation log"
    },
    "notFound": "Student not found",
    "emptyEnrollmentsTitle": "No enrollments yet",
    "emptyEnrollmentsBody": "Add an enrollment to assign a slot and start billing tuition.",
    "actions": {
      "menu": "Actions",
      "deactivate": "Deactivate student",
      "deactivateSuccess": "Student deactivated",
      "deactivateConfirmTitle": "Deactivate this student?",
      "deactivateConfirmDescription": "This will:",
      "deactivateBullet1": "End all of the student's active enrollments",
      "deactivateBullet2": "Remove the student from every slot and upcoming session",
      "deactivateBullet3": "Keep all existing billing history",
      "reactivate": "Reactivate",
      "reactivateSuccess": "Student reactivated",
      "delete": "Delete student",
      "deleteSuccess": "Student deleted",
      "deleteConfirmTitle": "Delete this student?",
      "deleteConfirmDescription": "This cannot be undone. If the student has billing history, this will be rejected and you'll be steered to \"Deactivate student\" instead.",
      "cancel": "Cancel",
      "confirm": "Confirm"
    },
    "editDialog": {
      "title": "Edit student",
      "name": "Full name",
      "nickname": "Nickname",
      "dob": "Date of birth",
      "payer": "Payer",
      "notes": "Notes",
      "tags": "Tags",
      "success": "Student updated",
      "payerReassignNotice": "The student still has {{count}} unpaid invoice(s) — those stay with the previous payer.",
      "submit": "Save",
      "submitting": "Saving...",
      "cancel": "Cancel"
    },
    "added": "Added",
    "age": "{{count}} yrs"
  },
  "popover": {
    "payer": "Payer",
    "gender": "Gender",
    "dob": "Date of birth",
    "openProfile": "Open student page",
    "loadError": "Could not load this student."
  },
  "enrollment": {
    "monthlyBillingHint": "Billed monthly via Close-the-month",
    "notAssignedBadge": "Not assigned to a class",
    "title": "Add enrollment",
    "subject": "Subject",
    "mode": {
      "label": "How this student pays",
      "recommended": "Recommended",
      "SESSION_MONTHLY": {
        "label": "Per session",
        "desc": "Counts sessions through the month, billed at close-the-month. Most common."
      },
      "SESSION_TERM": {
        "label": "Per term",
        "desc": "Paid upfront for a block of N sessions; renews when the block runs out."
      },
      "MONTHLY_FLAT": {
        "label": "Fixed monthly",
        "desc": "One fixed amount every month, regardless of sessions attended."
      }
    },
    "ratePerSession": "Rate per session (đ)",
    "monthlyRate": "Monthly fee (đ)",
    "chargeAbsent": "Charge no-notice absences",
    "termSize": "Sessions per term",
    "cancel": "Cancel",
    "submit": "Add",
    "submitting": "Saving...",
    "statusPaused": "Paused",
    "statusEnded": "Ended",
    "startDate": "Started {{date}}",
    "termProgress": "{{consumed}}/{{termSize}} sessions attended this term",
    "monthlyProgress": "{{count}} sessions attended",
    "monthlyProgress_one": "{{count}} session attended",
    "termRef": "{{size}}-session term",
    "termRefWithLabel": "{{size}}-session term ({{label}})",
    "actions": {
      "menu": "Actions",
      "pause": "Pause",
      "pauseSuccess": "Enrollment paused",
      "resume": "Resume",
      "resumeSuccess": "Enrollment resumed",
      "end": "End enrollment",
      "endSuccess": "Enrollment ended",
      "pauseConfirmTitle": "Pause this enrollment?",
      "pauseConfirmDescription": "The student's slot assignments are kept, but they won't appear in upcoming sessions. You can resume at any time.",
      "endConfirmTitle": "End this enrollment?",
      "endConfirmDescription": "This permanently stops the enrollment:",
      "endBullet1": "Removes the student from their slot assignments and upcoming sessions",
      "endBullet2": "Settles the current billing period one final time at the next Close-the-month",
      "endBullet3": "Resuming later requires re-assigning slots",
      "editRate": "Edit rate",
      "delete": "Delete enrollment",
      "deleteConfirmTitle": "Delete this enrollment?",
      "deleteConfirmDescription": "This cannot be undone. If the enrollment has billing history, this will be rejected and you'll be steered to \"End enrollment\" instead.",
      "confirm": "Confirm",
      "cancel": "Cancel"
    },
    "editRateDialog": {
      "title": "Edit how the fee is calculated",
      "description": "Applies to everything not yet invoiced — including the month you haven't closed yet. Already-closed periods are unchanged. If you want the not-yet-closed month to keep the old rule, close that month first, then come back and change this.",
      "chargeAbsentLabel": "Charge no-notice absences",
      "chargeAbsentTermHint": "Term enrollment: changing this mid-term re-counts the entire running term, so it may end sooner.",
      "success": "Rate updated",
      "submit": "Save",
      "submitting": "Saving...",
      "cancel": "Cancel"
    }
  },
  "term": {
    "notStarted": "Term not started",
    "start": "Start term",
    "renew": "Renew term",
    "startDateLabel": "Start date",
    "startConfirmTitle": "Start a new term?",
    "startConfirmDescription": "This will issue an invoice prepaying the full term. Are you sure you want to start it?",
    "renewConfirmTitle": "Renew term?",
    "renewConfirmDescription": "This will reconcile the current term and issue an invoice prepaying the next one. Are you sure you want to renew?",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "khoa": {
      "badgeNearlyOut": "{{count}} sessions left",
      "badgeNearlyOut_one": "{{count}} session left",
      "badgeOut": "Term used up",
      "consequenceNearlyOut": "{{count}} sessions left — remind the parent to pay before the term runs out.",
      "consequenceNearlyOut_one": "{{count}} session left — remind the parent to pay before the term runs out.",
      "consequenceOut": "The term is used up — collect tuition now so the next session isn't taught unpaid."
    }
  },
  "subjects": {
    "title": "Subjects",
    "subtitle": "Subject catalog and default rates",
    "add": "Add subject",
    "name": "Subject name",
    "perSession": "đ/session",
    "perMonth": "đ/month",
    "defaultRate": "Default rate / session (đ)",
    "defaultMonthlyRate": "Default rate / month (đ)",
    "empty": "No subjects yet",
    "emptyBody": "A subject sets the per-session or per-month price — invoices are calculated from it.",
    "create": "Add subject",
    "edit": "Edit subject",
    "delete": "Delete subject",
    "cancel": "Cancel",
    "submit": "Save",
    "menu": "Actions",
    "editDialog": {
      "title": "Edit subject",
      "name": "Subject name",
      "defaultRate": "Default rate / session (đ)",
      "defaultMonthlyRate": "Default rate / month (đ)",
      "rateHint": "Only applies to new enrollments — existing ones are unchanged",
      "success": "Subject updated",
      "submit": "Save",
      "submitting": "Saving...",
      "cancel": "Cancel"
    },
    "deleteConfirm": {
      "title": "Delete this subject?",
      "description": "This cannot be undone. Subjects with enrolled students cannot be deleted.",
      "confirm": "Confirm",
      "cancel": "Cancel"
    },
    "detail": {
      "students": "Current students",
      "empty": "No students in this subject yet",
      "notFound": "Subject not found",
      "emptyBody": "Students appear here once you add an enrollment in this subject for them.",
      "removeTemplate": "Remove template",
      "removeTemplateTitle": "Remove the note template?",
      "removeTemplateBody": "The session-note form goes back to a free-text box. Notes already written from the template still show in full.",
      "removeTemplateConfirm": "Remove template",
      "removeTemplateCancel": "Keep template"
    }
  }
}
